<template>
  <el-row>
    <el-col>
      <el-breadcrumb separator="/" class="admincrumb" style="font-size: 12px;">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>店铺</el-breadcrumb-item>
        <el-breadcrumb-item>挂单产品</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <el-col class="'toolbar" style="text-align: right;">
      <el-form :inline="true" :model="sData" name="squery" size="mini" ref="squery">
        <el-form-item style="flex: 1;" label="搜索条件">
          <el-input  v-model="sData.keywords" required placeholder="请输入搜索关键词，标题，spu,sku,等均可" style="flex: 1;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button-group>
            <el-button type="primary" @click="sSubmit('squery')"><i class="el-icon-search" style="font-weight: bolder; margin-right: 6px;"></i>产品搜索</el-button>
            <el-button type="primary" @click="makeNewListing"><i class="el-icon-plus" style="font-weight: bolder; margin-right: 6px;"></i>极速挂单</el-button>
            <el-button type="primary" @click="cwalShow = true"><i class="fa fa-edit" style="font-weight: bolder; margin-right: 6px;"></i>一键采集</el-button>
            <el-button type="primary" @click="repairImaes"><i class="fa fa-edit" style="font-weight: bolder; margin-right: 6px;"></i>主产品图片修复</el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
    </el-col>
     <el-dialog :visible.sync="listDiaVisiable" :before-close="handleClose" width="66%">
       <el-row>
         <el-col :span="24" class="listingnav" style="padding: 42px;">
          <el-steps :active="active">
            <el-step title="编辑基础信息" @click="tabnav(1)" description="请针对商品的标题，规格等信息进行基础的编辑"></el-step>
            <el-step title="变体编辑" @click="tabnav(2)" description="根据第一步的规格信息，系统将生成相应的变体，用户需要对子变体的信息加以完善"></el-step>
            <el-step title="属性编辑" @click="tabnav(3)" description="不同的分类的商品拥有不同的属性，用户需针对属性的设置做出来相应的处理"></el-step>
          </el-steps>
        </el-col>
         <el-col :span="24" style="padding: 42px;">
           <el-form :model="baseinfo" :hidden="baseboxvisible" label-width="120px" ref="baseinfo" id="baseinfo">
             <el-form-item label="产品标题" prop="title" :rules="{required: true, message: '产品标题不能为空', trigger: 'blur'}">
                <el-input v-model="baseinfo.title" placeholder="请输入产品标题"></el-input>
              </el-form-item>
             <el-form-item label="产品副标题" prop="subTitle" :rules="{required: true, message: '产品副标题不能为空', trigger: 'blur'}">
                <el-input v-model="baseinfo.subTitle" placeholder="请输入产品副标题"></el-input>
              </el-form-item>
             <el-form-item prop="isCustomerize" label="订制商品" required>
               <el-switch v-model="baseinfo.isCustomerize" active-color="#13ce66" inactive-color="#ff4949">></el-switch>
             </el-form-item>
             <div id="customer" v-if="baseinfo.isCustomerize" style="background: rgba(240,240,240,0.8)!important; margin-bottom: 26px; padding: 56px;">
               <h4>定制商品参数管理</h4>
               <el-form :model="customizeFields" ref="customerInitForm" size="small" style="display: flex; justify-content: flex-start;">
                 <el-form-item prop="fields" style="flex: 1;">
                   <el-input style="border-radius: 0!important;" v-model="customizeFields.fields"  placeholder="请输入你的定制产品标签并以英文';'分隔..."/>
                 </el-form-item>
                 <el-form-item>
                   <el-button-group>
                     <el-button type="primary" style="border-radius: 0!important; margin-left: -3px;" @click="csmInit">生成定制规则</el-button>
                   </el-button-group>
                 </el-form-item>
               </el-form>
               <div v-if="baseinfo.isCustomerize && customerize">
                 <el-form v-if="Object.keys(customerize).length > 0" :model="customerize" ref="customerTypeForm" size="small">
                   <div v-for="(vl, ks) in customerize" :key="ks + '.type'">
                     <el-form-item :label="ks" :prop="ks + '.type'" require>
                       <el-radio-group v-model="customerize[ks].type">
                         <el-radio label="text">文字属性</el-radio>
                         <el-radio label="images">图片属性</el-radio>
                         <el-radio label="number">数字属性</el-radio>
                         <el-radio label="fixValue">固定值</el-radio>
                       </el-radio-group>
                     </el-form-item>
                     <el-form-item :label="ks + '表单提示文字'" :prop="ks + '.placeorder'" require>
                       <el-input v-model="customerize[ks].placeorder" placeholder="请输入参数表单提示文字"/>
                     </el-form-item>
                     <el-form-item :label="ks + '表单填写说明'" :prop="ks + '.intro'" require>
                       <el-input type="textarea" :rows="5" v-model="customerize[ks].intro" placeholder="请输入参数填写说明"/>
                     </el-form-item>
                     <el-form-item :label="ks + '最大字符数'" :prop="ks + '.maxLength'" require>
                       <el-input-number v-model="customerize[ks].maxLength" label="请输入字符限制"/>
                     </el-form-item>
                     <el-form-item :label="ks + '定制费'" :prop="ks + '.extraCost'" require>
                       <el-input-number v-model="customerize[ks].extraCost" :precision="2" label="请输入参数定费"/>
                     </el-form-item>
                     <el-form-item :label="ks + '是否为必填参数'" :prop="ks + '.required'" require>
                       <el-radio-group v-model="customerize[ks].required">
                         <el-radio :label="true">必须填写</el-radio>
                         <el-radio :label="false">可选填写</el-radio>
                       </el-radio-group>
                     </el-form-item>
                     <div v-if="customerize[ks].type === 'number'" style="background-color: white; padding: 12px; margin-top: 16px; margin-bottom: 16px;">
                       <el-form-item :label="ks + '最小值'" :prop="ks + '.minValue'" require>
                         <el-input-number v-model="customerize[ks].minValue" label="请输入最小值"/>
                       </el-form-item>
                       <el-form-item :label="ks + '最大值'" :prop="ks + '.maxValue'" require>
                         <el-input-number v-model="customerize[ks].maxValue" label="请输入最大值"/>
                       </el-form-item>
                       <el-form-item :label="ks + '数字相关'" :prop="ks + '.refKey'" required>
                         <el-radio-group v-model="customerize[ks].refKey">
                           <el-radio :label="true">参数数字相关</el-radio>
                           <el-radio :label="false">参数数字不相关</el-radio>
                         </el-radio-group>
                       </el-form-item>
                       <el-form-item v-if="customerize[ks].refKey" :label="ks + '关联字段'" :prop="ks + '.ref'" required>
                         <el-checkbox-group v-model="customerize[ks].ref">
                           <el-checkbox v-for="(refvl, refks) in customerize" :key="refks" v-if="refvl.type !== 'number'" :label="refks">{{refks}}</el-checkbox>
                         </el-checkbox-group>
                       </el-form-item>
                     </div>
                     <div v-if="customerize[ks].type === 'fixValue'" style="background-color: white; padding: 12px; margin-top: 16px; margin-bottom: 16px;">
                       <el-form-item :label="ks + '固定值设定方式'" :prop="ks + '.fixChooseType'" required>
                         <el-radio-group v-model="customerize[ks].fixChooseType">
                           <el-radio label="input">录入固定值</el-radio>
                           <el-radio label="choose">从标准值中选取</el-radio>
                         </el-radio-group>
                       </el-form-item>
                       <el-form-item v-if="customerize[ks].fixChooseType === 'input'" :label="ks + '固定值'" ::prop="ks + '.values'" required>
                         <el-input v-model="customerize[ks].values" :placeholder="'请输入' + ks + '的固定值，并使用英文分号相隔'"/>
                       </el-form-item>
                       <el-form-item :label="ks + '固定值选择'" v-else>
                         <el-radio-group v-model="fixValueGroup">
                           <el-radio v-for="fix in fixValueGroup" :key="fix.id" :label="fix.id">{{fix.name}}</el-radio>
                         </el-radio-group>
                       </el-form-item>
                     </div>
                   </div>
                   <el-form-item style="text-align: right; margin-top: 16px;">
                     <el-button type="primary" @click="voteCustomer('customerTypeForm')">提交定制规则</el-button>
                   </el-form-item>
                 </el-form>
               </div>
               <div v-if="baseinfo.customerize">
                 <el-divider/>
                 <h3>定制商品参数:</h3>
                 <div style="padding-bottom: 16px;" v-for="(vl, ks) in baseinfo.customerize" :key="ks">
                   <h5>{{ks}}</h5>
                   <p><b style="margin-right: 8px;">属性类型:</b>{{vl.type}}</p>
                   <p><b style="margin-right: 8px;">定制费:</b>{{vl.extraCost}}</p>
                   <p><b style="margin-right: 8px;">属性指定值:</b>{{vl.values.length > 0 ? vl.values : '无指定值'}}</p>
                   <p><b style="margin-right: 8px;">属性指定值:</b>{{vl.values.required ? '必须填写' : '选择性填写'}}</p>
                   <p><b style="margin-right: 8px;">关联字段:</b>{{vl.refKey.length > 0 ? vl.refKey.join(';') : '无需关联值'}}</p>
                   <p><b style="margin-right: 8px;">表单提示:</b>{{vl.placeorder}}</p>
                   <p><b style="margin-right: 8px;">报写说明:</b>{{vl.intro}}</p>
                   <p><b style="margin-right: 8px;">字符限制:</b>{{vl.maxLength}}</p>
                   <p><b style="margin-right: 8px;">最小值:</b>{{vl.minValue}}</p>
                   <p><b style="margin-right: 8px;">最大值:</b>{{vl.maxValue}}</p>
                   <el-divider/>
                 </div>
               </div>
             </div>
             <el-form-item label="品牌名" prop="brandName" :rules="{required: true, message: '产品品牌名不能为空', trigger: 'blur'}">
                <el-input v-model="baseinfo.brandName" placeholder="请输入产品品牌名"></el-input>
              </el-form-item>
               <el-form-item label="SPU" prop="spu" :rules="{required: true, message: '产品spu不能为空', trigger: 'blur'}">
                <el-input v-model="baseinfo.spu" placeholder="请输入产品SPU"></el-input>
              </el-form-item>
             <el-form-item label="挂单价格" prop="listingPrice" :rules="{required: true, message: '产品挂单价格不能为空', trigger: 'blur'}">
                <el-input v-model="baseinfo.listingPrice" placeholder="请输入产品挂单价格"></el-input>
              </el-form-item>
             <el-form-item label="销售价格" prop="salePrice" :rules="{required: true, message: '产品销售价格不能为空', trigger: 'blur'}">
                <el-input v-model="baseinfo.salePrice" placeholder="评价输入产品销售价格"></el-input>
              </el-form-item>
             <el-form-item label="产品分类" required>
                <el-popover ref="catpopover" v-loading="cloading" placement="bottom-start" width="100%" trigger="click" v-model='popshow'>
                  <el-tag v-for="tag in currCategoryList" :key="tag.ID" type="success"><span @click="categorychecked(tag)">{{ tag.name }}</span></el-tag>
                </el-popover>
                <el-button @click="initcategory" style="width: 100%;" v-popover:catpopover>{{ currCatgery.route }}</el-button>
                <el-input v-model="baseinfo.category_id" style="display: none"></el-input>
              </el-form-item>
              <span v-for="(taggroup, idx) in baseinfo.standard" :key="taggroup.ID">
                <span class="devideline">{{ taggroup.showName }}</span>
                <el-form-item v-for="(ftg, index) in taggroup.tag" :key="ftg.ID" :label="ftg.showName" :prop="'standard.'+idx+'.tag.'+index+'.value'" :rules="{required: true, message: '产品购物选择项不能为空', trigger: 'blur'}">
                  <el-input v-model="ftg.value" placeholder="请输入产品的必填项"></el-input>
                </el-form-item>
              </span>
              <el-form-item label="产品库存" prop="qty" :rules="{required: true, message: '产品库存数不能为空', trigger: 'blur'}">
              <el-input v-model="baseinfo.qty" placeholder="请输入产品库存"></el-input>
              </el-form-item>
              <el-form-item label="发货地" prop="shippingFrom" :rules="{required: true, message: '产品发货地不能为空', trigger: 'blur'}">
                <el-select v-model="baseinfo.shippingFrom" auto-complete filterable placeholder="请选择配送国家" size="medium">
                  <el-option v-for="ccode in country" :key="ccode.ID"  :label='ccode.ShowName' :value="ccode.CCODE"></el-option>
                </el-select>
              </el-form-item>
             <el-form-item label="搜索关键词" prop="tags" :rules="{required: true, message: '产品关键词能为空', trigger: 'blur'}">
                <el-input v-model="baseinfo.tags" placeholder="请输入产品搜索关键词"></el-input>
              </el-form-item>
             <el-form-item label="产品简介" prop="synopsys" :rules="{required: true, message: '产品简介不能为空', trigger: 'blur'}">
                <el-input type="textarea" :rows="7" v-model="baseinfo.synopsys" placeholder="请输入产品简介"></el-input>
              </el-form-item>
             <el-form-item label="产品描述" prop="content" :rules="{required: true, message: '产品描述不能为空', trigger: 'blur'}">
               <vue-editor v-model="baseinfo.content" style="height: 400px; overflow-y: auto;" @imageAdded="imgLoad" useCustomImageHandler></vue-editor>
              </el-form-item>
              <el-form-item style="text-align: right;">
                <el-button type="primary" @click="basenext('baseinfo')">下一步</el-button>
              </el-form-item>
           </el-form>
           <el-form :model="imagesMap" :hidden="attributeboxvisible" label-width="120px" ref="attribute" id="attribute">
             <span v-for="(target, index) in imagesMap" :key="index">
               <div class="prefixname"><span class="dh">当前图片标签组:</span><span class="currnav">{{ target.group.showName }}_{{ target.attri.showName }}</span></div>
               <el-tabs @tab-click="handtabclick" stretch>
                 <el-tab-pane v-for="tb in target.spec" :key="tb.key" :label="tb.key" :name="target.group.name+'_'+target.attri.name+'_'+tb.key">
                   <span v-for="(img, serindex) in tb.list" :key="img">
                     <div v-if="img == tb.cover" class="iscover imgcell" @dblclick="handImgRemove(serindex)" @click="handimgclick(img)"><img :src="img"/></div>
                     <div v-else class="imgcell" @dblclick="handImgRemove(serindex)" @click="handimgclick(img)"><img :src="img"/></div>
                   </span>
                 </el-tab-pane>
               </el-tabs>
              </span>
              <div :span="24" class="uploadbox">
                <el-upload class="upload" drag :data="uploadattr" accept="image/*" :on-success="pushtobox" name="upload" :headers="$verifyhead" :action="upurl" multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">只能上传png/jpg类型图片</div>
              </el-upload>
              </div>
             <span>
               <el-form inline>
                 <el-table :data="variant" stripe title height="420"  style="width: 100%">
                   <el-table-column prop="standardString" label="规格"></el-table-column>
                   <el-table-column prop="listingPrice" label="挂单价"></el-table-column>
                   <el-table-column prop="salePrice" label="销售价"></el-table-column>
                   <el-table-column prop="qty" label="库存数"></el-table-column>
                   <el-table-column label="操作">
                     <template slot-scope="scope">
                      <el-button @click.native.prevent="editskurow(scope.$index,scope.row)" type="text" size="small">编辑</el-button>
                      <el-button @click.native.prevent="handleRemoveClick(scope.$index)" type="text" size="small">移除</el-button>
                    </template>
                   </el-table-column>
                 </el-table>
               </el-form>
             </span>
             <el-dialog title="子变体编辑" :visible.sync="vareditboxshow" append-to-body>
               <form :model="currVariaCol" ref="updatevariant">
                 <el-form-item label="挂单价" prop="listingPrice">
                    <el-input v-model="currVariaCol.listingPrice" placeholder="请输入产品挂单价"></el-input>
                  </el-form-item>
                 <el-form-item label="销售价" prop="salePrice">
                    <el-input v-model="currVariaCol.salePrice" placeholder="请输入产品销售价"></el-input>
                  </el-form-item>
                 <el-form-item label="库存数" prop="qty">
                    <el-input v-model="currVariaCol.qty" placeholder="请输入产品库存数"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="skuUpdate">更新变体</el-button>
                  </el-form-item>
               </form>
             </el-dialog>
             <el-form-item style="text-align: right;">
                <el-button type="primary" @click="prestep">上一步</el-button>
                <el-button type="primary" @click="steptoattri('attribute')">下一步</el-button>
              </el-form-item>
           </el-form>
           <el-form :model="canshu" :hidden="attrlistboxvisible" ref="canshu">
             <el-form-item v-for="(group, key) in attrlist" :key="group.taginfomation.ID" :label="group.taginfomation.showName" :prop="key" required>
               <el-radio-group v-if="group.valueList.length > 0" v-model="canshu[key]">
                 <el-radio v-for="radioitem in group.valueList" :key="radioitem.ID + '_' + radioitem.attri_id" :label="radioitem.value">{{ radioitem.field }}</el-radio>
               </el-radio-group>
               <el-input v-else v-model="canshu[key]" placeholder="请输入必填项值"></el-input>
             </el-form-item>
             <el-form-item style="text-align: right;">
                <el-button type="primary" @click="prevarstep">上一步</el-button>
                <el-button type="primary" @click="applynow">产品提交</el-button>
              </el-form-item>
           </el-form>
         </el-col>
       </el-row>
    </el-dialog>
    <el-col :span="24" class="pshow">
      <el-col>
        <el-table v-loading="pageloading" element-loading-text="拼命加载中..." element-loading-spinner="el-icon-loading" :data="pageinfo.data" stripe style="width: 100%">
            <el-table-column prop="child[0].cover" label="封面" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.child[0]" >
                  <img :src="scope.row.child[0].cover" width="100%"/>
                </span>
                <span v-else>
                  <i class="el-icon-picture" style="font-size: 56px;"></i>
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="spu" label="SPU" width="200"></el-table-column>
            <el-table-column prop="itemsku" label="商户SKU" width="150"></el-table-column>
            <el-table-column prop="title" label="产品标题" width="300"></el-table-column>
            <el-table-column prop="brandName" label="产品品牌" width="110"></el-table-column>
            <el-table-column prop="category.name" label="产品分类" width="110"></el-table-column>
            <el-table-column prop="currency" label="货币" width="50"></el-table-column>
            <el-table-column prop="listingPrice" label="挂单价" width="110"></el-table-column>
            <el-table-column prop="salePrice" label="销售价" width="110"></el-table-column>
            <el-table-column prop="status" label="状态">
              <template slot-scope="scop">
                <el-tag v-if="scop.row.status" type="success">可售</el-tag>
                <el-tag v-else type="danger">不可售</el-tag>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="产品管理" width="250" align="center">
              <template slot-scope="scope">
                <el-button-group style="text-align: right;">
                  <el-button type="text" size="small" @click="removeSpu(scope.row.spu)">移除</el-button>
                  <el-button type="text" size="small" @click="GetEditVariant(scope.row)">变体</el-button>
                  <el-button type="text" size="small" @click="exattr(scope.row)">属性</el-button>
                  <el-button type="text" size="small" @click="inirCoverEditor(scope.row)">图片</el-button>
                  <el-button type="text" size="small" @click="showEditBox(scope.row)">编辑</el-button>
                  <el-button type="text" size="small" @click="repairStandard(scope.row.spu)">变体修复</el-button>
                  <el-button type="text" size="small" v-if="scope.row.customize === 1" @click="initEditCmz(scope.row)">定制编辑</el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
      </el-col>
    </el-col>
    <el-col :span="24" class="pagenav" style="margin-top: 42px;">
        <el-pagination
        @current-change="handleCurrentChange"
        :current-page="pageinfo.page"
        :page-sizes="[12]"
        :page-size="12"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageinfo.total">
      </el-pagination>
      <el-dialog title="产品基础信息编辑" :visible.sync="editdiashow" append-to-body>
        <el-form :model="curreditspu"  label-width="120px" name="spueditform" ref="spueditform">
          <el-form-item label="产品标题" prop="title" required>
            <el-input v-model="curreditspu.title" placeholder="输入产品标题"></el-input>
          </el-form-item>
          <el-form-item label="产品副标题" prop="subTitle" required>
            <el-input v-model="curreditspu.subTitle" placeholder="输入产品副标题"></el-input>
          </el-form-item>
           <el-form-item prop="qty" label="产品库存" required>
            <el-input v-model="curreditspu.qty" placeholder="请输入产品库存"></el-input>
          </el-form-item>
          <el-form-item prop="status" label="产品可售" required>
            <el-switch v-model="curreditspu.status" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
          </el-form-item>
           <el-form-item label="挂单价格" prop="subTitle" required>
            <el-input v-model="curreditspu.listingPrice" placeholder="输入产品挂单价格"></el-input>
          </el-form-item>
          <el-form-item label="销售价格" prop="subTitle" required>
            <el-input v-model="curreditspu.salePrice" placeholder="输入产品销售价格"></el-input>
          </el-form-item>
          <el-form-item label="产品品牌" prop="brandName" required>
            <el-input v-model="curreditspu.brandName" placeholder="输入产品品牌"></el-input>
          </el-form-item>
          <el-form-item label="商家SPU" prop="itemsku" required>
            <el-input v-model="curreditspu.itemsku" placeholder="输入商家SPU"></el-input>
          </el-form-item>
          <el-form-item label="搜索关键词" prop="tags" required>
            <el-input v-model="curreditspu.tags" placeholder="输入产品搜索关键词"></el-input>
          </el-form-item>
          <el-form-item label="短描述" prop="synopsys" required>
            <el-input type="textarea" :rows="5" v-model="curreditspu.synopsys" placeholder="输入产品短描述"></el-input>
          </el-form-item>
          <el-form-item label="发货地" prop="shippingFrom" required>
            <el-input v-model="curreditspu.shippingFrom" placeholder="输入产品发货地"></el-input>
          </el-form-item>
          <el-form-item label="产品描述" prop="content" :rules="{required: true, message: '产品描述不能为空', trigger: 'blur'}">
            <vue-editor v-model="curreditspu.content" style="height: 400px; overflow-y: auto;" @imageAdded="imgLoad" useCustomImageHandler></vue-editor>
          </el-form-item>
          <el-form-item style="text-align: right;">
            <el-button type="primary" @click="editdiashow = false">取 消</el-button>
            <el-button type="primary" @click="handleSpuUpdate('spueditform')">产品提交</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-col>
    <el-dialog :visible.sync="cwalShow">
      <el-form :model="cwalData" name="cwalForm" ref="cwalForm">
        <el-form-item label="采集地址" prop="cralurl" required>
          <el-input v-model="cwalData.cralurl" placeholder="请输入采集url地址"></el-input>
        </el-form-item>
        <el-form-item style="text-align:right;">
          <el-button type="success" @click="cwaNow('cwalForm')"><i class="fa fa-cloud-upload"></i>产品采集</el-button>
        </el-form-item>
      </el-form>
      <el-form :model="currCwal" name="newcwalForm" ref="newcwalForm">
         <el-form-item label="产品标题" prop="title" required>
          <el-input v-model="currCwal.title" placeholder="产品标题"></el-input>
        </el-form-item>
         <el-form-item label="关键词" prop="keywords" required>
          <el-input v-model="currCwal.keywords" placeholder="关键词"></el-input>
        </el-form-item>
        <el-form-item label="产品分类" prop="category_id" required>
          <el-popover ref="cralpopover" v-loading="flloading" placement="bottom-start" width="100%" trigger="click" v-model='cralpopshow'>
            <el-tag v-for="tag in currcwalCategoryList" :key="tag.ID" type="success"><span @click="cwalcategorychecked(tag)">{{ tag.name }}</span></el-tag>
          </el-popover>
          <el-button @click="initCralcategory" style="width: 100%;" v-popover:cralpopover>{{ currCralCategory.route }}</el-button>
          <el-input v-model="currCwal.category_id" style="display: none"></el-input>
        </el-form-item>
         <el-form-item label="产品价格" prop="listingPrice" required>
          <el-input v-model="currCwal.listingPrice" placeholder="请输入产品价格"></el-input>
        </el-form-item>
         <el-form-item label="销售价格"  prop="salePrice" required>
          <el-input v-model="currCwal.salePrice" placeholder="请输入销售价格"></el-input>
        </el-form-item>
         <el-form-item label="产品描述"  prop="content" required>
           <vue-editor v-model="currCwal.content" style="height: 400px; overflow-y: auto;" @imageAdded="imgLoad" useCustomImageHandler></vue-editor>
        </el-form-item>
        <el-form-item style="text-align: right">
          <template>
            <el-button-group>
              <el-button type="success" @click="handleCral('newcwalForm')"><i class="fa fa-shopping-bag"></i>快速挂单</el-button>
            </el-button-group>
          </template>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="showvarianteditbox" fullscreen>
      <el-table :data="editvariant" stripe>
        <el-table-column prop="cover" label="封面" width="110">
          <template slot-scope="scope">
            <span v-if="scope.row" >
              <img :src="scope.row.cover" width="100%" style="height: 110px; width: 110px; border-radius: 55px; object-fit: cover;"/>
            </span>
            <span v-else>
              <i class="el-icon-picture" style="font-size: 56px;"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="sku" label="SKU" width="250"></el-table-column>
        <el-table-column prop="standard" label="产品规格">
          <template slot-scope="scop">
            <el-tag v-for="std in scop.row.standard.keyString.split(',')" :key="std" type="danger">{{ std }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="listingPrice" label="挂单价格"></el-table-column>
        <el-table-column prop="salePrice" label="销售价格"></el-table-column>
        <el-table-column prop="qty" label="产品库存"></el-table-column>
        <el-table-column prop="status" label="变体状态">
          <template slot-scope="scop">
            <el-tag v-if="scop.row.status" type="success">可售</el-tag>
            <el-tag v-else type="danger">不可售</el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="变体管理" style="text-align: right;">
          <template slot-scope="scope">
            <el-button-group>
              <el-button type="text" size="small" @click="exvariant(scope.row)">编辑</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :visible.sync="variantrenew" append-to-body>
      <el-form :model="currrenew" ref="veditForm">
        <el-form-item prop="qty" label="产品库存" required>
          <el-input v-model="currrenew.qty" placeholder="请输入产品库存"></el-input>
        </el-form-item>
        <el-form-item prop="status" label="产品可售" required>
          <el-switch v-model="currrenew.status" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
        </el-form-item>
        <el-form-item prop="listingPrice" label="挂单价格" required>
          <el-input v-model="currrenew.listingPrice" placeholder="请输入挂单价格"></el-input>
        </el-form-item>
        <el-form-item prop="salePrice" label="销售价格" required>
          <el-input v-model="currrenew.salePrice" placeholder="请输入销售价格"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" @click="renewchild('veditForm')">变体更新</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="showattreditor" append-to-body>
      <el-form :model="currattr" ref="attrForm">
        <span v-for="(item,key) in currattr" :key="key">
          <el-form-item :prop="key + '.value'" :label="item.taginfomation.showName" v-if="key !== 'ID'">
            <el-input v-model="currattr[key].value" :placeholder="'请输入' + item.taginfomation.showName"></el-input>
          </el-form-item>
        </span>
        <el-form-item style="text-align: right;">
          <el-button type="primary" @click="renewattri('attrForm')">属性更新</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="imagesShow" top="3vh" width="80%">
      <h3 slot="title">产品图片编辑</h3>
      <el-form>
        <el-form-item label="图片变体主键:">
          <el-tag v-for="kk in coverImagesKey" :key="kk" type="warning">{{kk}}</el-tag>
        </el-form-item>
      </el-form>
      <el-row v-if="itemImages.length > 0" style="display: flex; justify-content: flex-start; align-items: stretch; flex-wrap: wrap; margin-top: 16px; height: 50vh!important; overflow-y: auto;">
        <el-col :span="6" style="padding: 8px; margin-bottom: 22px;" v-for="item in itemImages" :key="item" class="showcell">
          <el-image :src="item" fit/>
          <el-row style="text-align: center;">
            <el-button-group>
              <el-button type="text" style="color: brown;"><i class="fa fa-scissors"></i>取用</el-button>
            </el-button-group>
          </el-row>
        </el-col>
      </el-row>
      <div class="covercontains" v-for="(kkv, kks) in coverMap" :key="kks" style="margin-top: 16px;">
        <el-divider/>
        <h3>{{kks}}</h3>
        <el-row>
          <el-col :span="4">
            <el-image :src="kkv.cover" fit/>
          </el-col>
          <el-col v-for="ccimg in kkv.images" :key="ccimg" :span="4">
            <el-image :src="ccimg" fit/>
            <el-row>
              <el-button-group>
                <el-button type="text" style="color: brown;"><i class="fa fa-remove" style="margin-right: 6px!important;"></i>删除</el-button>
                <el-button type="text" style="color: brown;"><i class="fa fa-eye" style="margin-right: 6px!important;"></i>封面</el-button>
              </el-button-group>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="cmzEditShow">
      <h3 slot="title">定制商品编辑</h3>
      <el-form :model="cmzEditFields" ref="cmzFieldGenertor" size="small" style="display: flex; justify-content: flex-start;">
        <el-form-item style="flex: 1;">
          <el-input v-model="cmzEditFields" style="border-radius: 0!important;" placeholder="请输入用户自定义的字段"/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="border-radius: 0!important; margin-left: -3px;" size="small" @click="upCmzFields">生成规则</el-button>
        </el-form-item>
      </el-form>
      <el-form v-if="Object.keys(currCmzEditCustomerize).length > 0" :model="currCmzEditCustomerize" ref="customerTypeForm" size="small">
        <div v-for="(vl, ks) in currCmzEditCustomerize" :key="ks">
          <el-form-item :label="ks" :prop="ks + '.type'" require>
            <el-radio-group v-model="currCmzEditCustomerize[ks].type">
              <el-radio label="text">文字属性</el-radio>
              <el-radio label="images">图片属性</el-radio>
              <el-radio label="number">数字属性</el-radio>
              <el-radio label="fixValue">固定值</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="ks + '表单提示文字'" :prop="ks + '.placeorder'" require>
            <el-input v-model="currCmzEditCustomerize[ks].placeorder" placeholder="请输入参数表单提示文字"/>
          </el-form-item>
          <el-form-item :label="ks + '表单填写说明'" :prop="ks + '.intro'" require>
            <el-input type="textarea" :rows="5" v-model="currCmzEditCustomerize[ks].intro" placeholder="请输入参数填写说明"/>
          </el-form-item>
          <el-form-item :label="ks + '最大字符数'" :prop="ks + '.maxLength'" require>
            <el-input-number v-model="currCmzEditCustomerize[ks].maxLength" label="请输入字符限制"/>
          </el-form-item>
          <el-form-item :label="ks + '定制费'" :prop="ks + '.extraCost'" require>
            <el-input-number v-model="currCmzEditCustomerize[ks].extraCost" :precision="2" label="请输入参数定费"/>
          </el-form-item>
          <el-form-item :label="ks + '是否为必填参数'" :prop="ks + '.required'" require>
            <el-radio-group v-model="currCmzEditCustomerize[ks].required">
              <el-radio :label="true">必须填写</el-radio>
              <el-radio :label="false">可选填写</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="currCmzEditCustomerize[ks].type === 'number'" style="background-color: white; padding: 12px; margin-top: 16px; margin-bottom: 16px;">
            <el-form-item :label="ks + '最小值'" :prop="ks + '.minValue'" require>
              <el-input-number v-model="currCmzEditCustomerize[ks].minValue" label="请输入最小值"/>
            </el-form-item>
            <el-form-item :label="ks + '最大值'" :prop="ks + '.maxValue'" require>
              <el-input-number v-model="currCmzEditCustomerize[ks].maxValue" label="请输入最大值"/>
            </el-form-item>
            <el-form-item :label="ks + '数字相关'" :prop="ks + '.refKey'" required>
              <el-radio-group v-model="currCmzEditCustomerize[ks].refKey">
                <el-radio :label="true">参数数字相关</el-radio>
                <el-radio :label="false">参数数字不相关</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="currCmzEditCustomerize[ks].refKey" :label="ks + '关联字段'" :prop="ks + '.ref'" required>
              <el-checkbox-group v-model="currCmzEditCustomerize[ks].ref">
                <el-checkbox v-for="(refvl, refks) in currCmzEditCustomerize" :key="refks" v-if="refvl.type !== 'number'" :label="refks">{{refks}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
          <div v-if="currCmzEditCustomerize[ks].type === 'fixValue'" style="background-color: white; padding: 12px; margin-top: 16px; margin-bottom: 16px;">
            <el-form-item :label="ks + '固定值设定方式'" :prop="ks + '.fixChooseType'" required>
              <el-radio-group v-model="currCmzEditCustomerize[ks].fixChooseType">
                <el-radio label="input">录入固定值</el-radio>
                <el-radio label="choose">从标准值中选取</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="currCmzEditCustomerize[ks].fixChooseType === 'input'" :label="ks + '固定值'" ::prop="ks + '.values'" required>
              <el-input v-model="currCmzEditCustomerize[ks].values" :placeholder="'请输入' + ks + '的固定值，并使用英文分号相隔'"/>
            </el-form-item>
            <el-form-item :label="ks + '固定值选择'" v-else>
              <el-radio-group v-model="fixValueGroup">
                <el-radio v-for="fix in fixValueGroup" :key="fix.id" :label="fix.id">{{fix.name}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div slot="footer" style="text-align: right;">
        <el-button type="primary" @click="handleNewCustomerize">提交定制更新</el-button>
      </div>
    </el-dialog>
</el-row>
</template>
<script>
import ElRow from 'element-ui/packages/row/src/row'
import ElCol from 'element-ui/packages/col/src/col'
export default{
  components: {
    ElCol,
    ElRow
  },
  name: 'Listing',
  data () {
    return {
      sData: {},
      pageinfo: {page: 0, total: 0, num: 8, data: []},
      attrlist: {},
      listDiaVisiable: false,
      vareditboxshow: false,
      attrlistboxvisible: true,
      images: {},
      catpopovershow: false,
      attributeboxvisible: true,
      uploadattr: {method: 'base.upload'},
      active: 0,
      baseboxvisible: false,
      catpopover: false,
      cralCatPopover: false,
      currCatgery: {route: '店铺根目录'},
      upurl: this.$apiurl,
      popshow: false,
      baseinfo: {standard: []},
      cloading: false,
      checkshow: true,
      category: [{name: '网店根分类', ID: '0', value: 0}],
      props: {
        label: 'name',
        value: 'ID',
        children: 'child'
      },
      tagprops: {
        tagname: 'tag.name',
        field: 'taggroup.information.showName' + '_' + 'tag.name'
      },
      currCategoryList: [],
      currcwalCategoryList: [],
      currAttribute: {},
      currTags: {},
      currimgtab: {},
      imagesMap: {},
      currVariaCol: {},
      variant: [],
      country: [],
      editorOption: {},
      editdiashow: false,
      curreditspu: {},
      pageloading: false,
      cwalShow: false,
      cwalData: {channel: 'aliexpress'},
      catepop: false,
      cralpopshow: false,
      currCwal: {},
      currCralCategory: {route: '店铺根目录'},
      flloading: false,
      cwaluuid: '',
      Interval: '',
      canshu: {},
      editvariant: [],
      showvarianteditbox: false,
      variantrenew: false,
      currrenew: {},
      showattreditor: false,
      currattr: {},
      imagesShow: false,
      coverMap: {},
      coverImagesKey: [],
      itemImages: [],
      keyItems: {},
      customizeFields: {},
      customerize: {},
      cmzEditShow: false,
      currCmzEdit: {},
      currCmzEditCustomerize: {},
      cmzEditFields: '',
      fixValueGroup: [{id: 22222, name: 'color', values: ['red', 'black']}],
      currFixGroup: ''
    }
  },
  mounted: function () {
    this.LoadChildCategory(0)
    this.loadcountry()
    this.handleCurrentChange(1)
  },
  watch: {
    imagesMap: function (o, n) {
      console.log('新')
    }
  },
  methods: {
    /**
     * 重组定制参数
     */
    upCmzFields: function () {
      var dd = this.cmzEditFields.split(';')
      var that = this
      var tmp = that.currCmzEditCustomerize
      dd.forEach(function (key) {
        if (!tmp[key]) {
          var obj = {}
          obj.key = key
          obj.values = ''
          obj.type = 'text'
          obj.fixChooseType = 'input'
          obj.valueRef = ''
          obj.placeorder = ''
          obj.intro = ''
          obj.required = true
          obj.ref = []
          obj.refKey = false
          obj.maxLength = 2000
          obj.minValue = 1
          obj.maxValue = 10000
          obj.extraCost = 0.00
          that.$set(that.currCmzEditCustomerize, key, obj)
        }
      })
      var newfields = {}
      Object.keys(tmp).forEach(function (chkey) {
        if (dd.indexOf(chkey) !== -1) {
          newfields[chkey] = that.currCmzEditCustomerize[chkey]
        }
      })
      that.currCmzEditCustomerize = newfields
    },
    /**
     * 提交新的定制产品参数
     */
    handleNewCustomerize: function () {
      var that = this
      var para = {}
      para.customerize = JSON.stringify(that.currCmzEditCustomerize)
      para.method = 'shop.updateCustomerize'
      para.spuId = that.currCmzEdit.ID
      that.fullLoad()
      this.$http.post(that.$apiurl, para).then(function (ret) {
        that.hasloaded()
        if (ret.data.data.code === 200) {
          this.$message.success('产品定制参数更新成功')
          that.handleCurrentChange(that.pageinfo.page)
        } else {
          this.$message.error('产品定制参数更新失败,请稍后重试')
        }
      })
    },
    /**
     * 提交定制参数
     * @param formName
     */
    voteCustomer: function (formName) {
      var that = this
      that.$refs[formName].validate(function (valid) {
        if (valid) {
          that.$set(that.baseinfo, 'customerize', that.customerize)
        }
      })
    },
    /**
     * 初始化定制商品参数
     * @param row
     */
    initEditCmz: function (row) {
      console.log(row.customizeAttribute)
      this.currCmzEdit = row
      if (!row.ref) {
        row.ref = []
      }
      if (!row.fixChooseType) {
        row.fixChooseType = 'input'
      }
      if (!row.placeorder) {
        row.placeorder = ''
      }
      if (!row.intro) {
        row.intro = ''
      }
      if (!row.refKey) {
        row.refKey = false
      }
      if (!row.required) {
        row.required = true
      }
      if (!row.valueRef) {
        row.valueRef = ''
      }
      if (!row.maxLength) {
        row.maxLength = 2000
      }
      if (!row.minValue) {
        row.minValue = 1
      }
      if (!row.maxValue) {
        row.maxValue = 10000
      }
      if (!row.extraCost) {
        row.extraCost = 0.00
      }
      this.currCmzEditCustomerize = row.customizeAttribute
      this.cmzEditFields = Object.keys(row.customizeAttribute).join(';')
      this.cmzEditShow = true
    },
    /***
     * 定制商品参数详情序列化
     */
    csmInit: function () {
      var curr = this.customizeFields.fields.split(';')
      var that = this
      var cmz = {}
      curr.forEach(function (field) {
        var obj = {}
        obj.key = field
        obj.values = ''
        obj.type = 'text'
        obj.ref = []
        obj.fixChooseType = 'input'
        obj.placeorder = ''
        obj.intro = ''
        obj.refKey = false
        obj.required = true
        obj.valueRef = ''
        obj.maxLength = 2000
        obj.minValue = 1
        obj.maxValue = 10000
        obj.extraCost = 0.00
        cmz[field] = obj
      })
      that.customerize = cmz
    },
    /**
     * 规格格修复
     * @param spu
     */
    repairStandard: function (spu) {
      var that = this
      var para = {}
      para.method = 'shop.standardRepair'
      para.spu = spu
      this.$http.post(that.$apiurl, para).then(function (ret) {
        if (ret.data.data.code === 200) {
          this.$message.success('产品变体修复完成')
        } else {
          this.$message.error('产品变体当前无法修复,请稍后重试')
        }
      })
    },
    /**
     * 主图修复
     */
    repairImaes: function () {
      var that = this
      var para = {}
      para.method = 'shop.spuimagesrepair'
      this.$http.post(that.$apiurl, para)
      this.$message.success('产品主图修复已经开始,请静待系统自动化处理')
    },
    /**
     * 封面编辑初始化
     * @param row
     */
    inirCoverEditor: function (row) {
      this.coverKey = ''
      var ks = []
      var imgmap = {}
      var img = []
      var km = {}
      row.child.forEach(function (item) {
        item.standard.info.forEach(function (curr) {
          if (curr.tag.isImages && ks.indexOf(curr.key) === -1) {
            ks.push(curr.key)
            var mp = {}
            mp.key = curr.key
            mp.group = curr.group.name
            mp.tag = curr.tag.name
            mp.cover = curr.tag.cover
            mp.images = curr.tag.imglist
            imgmap[curr.key] = mp
            img.push(curr.tag.cover)
            curr.tag.imglist.forEach(function (cimg) {
              if (img.indexOf(cimg) === -1) {
                img.push(cimg)
              }
            })
          }
          if (curr.tag.isImages) {
            if (!km[curr.key]) {
              km[curr.key] = []
            }
            km[curr.key].push(curr.ID)
          }
        })
      })
      this.coverImagesKey = ks
      this.coverMap = imgmap
      this.itemImages = img
      this.imagesShow = true
      this.keyItems = km
    },
    /**
     * 图片加载
     * @param file
     * @param Editor
     * @param cursorLocation
     * @param resetUploader
     */
    imgLoad: function (file, Editor, cursorLocation, resetUploader) {
      var foemData = new FormData()
      foemData.append('upload', file)
      var api = this.upurl
      var that = this
      that.$http.post(api, foemData).then(function (ret) {
        var imgurl = 'https:' + ret.body.data.url
        Editor.insertEmbed(cursorLocation, 'image', imgurl)
      })
    },
    /**
     * 额外参数
     * @param row
     */
    exattr: function (row) {
      var attr = row.attribute
      attr.ID = row.ID
      this.currattr = attr
      this.showattreditor = true
    },
    /**
     * 子变体更新
     * @param form
     */
    renewchild: function (form) {
      var that = this
      that.$refs[form].validate(function (valid) {
        if (valid) {
          var para = that.currrenew
          para.method = 'shop.updatevariant'
          delete para.standard
          delete para.attribute
          delete para.images
          delete para.category
          delete para.child
          delete para.currency
          delete para.sku
          delete para.cover
          delete para.figure
          delete para.updateAt
          delete para.creatAt
          that.fullLoad()
          that.$http.post(that.$apiurl, para).then(function (ret) {
            that.hasloaded()
            if (ret.body.code === 200) {
              that.$alert('变体更新成功!')
              that.showvarianteditbox = false
            } else {
              that.$alert('变体更新失败')
            }
          })
        }
      })
    },
    /**
     * 更新参数值
     * @param form
     */
    renewattri: function (form) {
      var that = this
      that.$refs[form].validate(function (valid) {
        if (valid) {
          var para = that.currattr
          para.method = 'shop.upattribute'
          that.fullLoad()
          that.$http.post(that.$apiurl, para).then(function (ret) {
            that.hasloaded()
            if (ret.body.code === 200) {
              that.$alert('属性更新成功!')
              that.showattreditor = false
            } else {
              that.$alert('属性更新失败')
            }
          })
        }
      })
    },
    /**
     * 变体编辑初始化
     * @param row
     */
    exvariant: function (row) {
      this.currrenew = row
      this.variantrenew = true
    },
    hasloaded: function () {
      this.load.close()
      this.load = ''
    },
    fullLoad () {
      this.load = this.$loading({
        lock: true,
        text: '请求处理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    prestep: function () {
      this.baseboxvisible = false
      this.attributeboxvisible = true
      this.active--
    },
    prevarstep: function () {
      this.attrlistboxvisible = true
      this.attributeboxvisible = false
      this.active--
    },
    handleImgtabClick: function (e, tab) {
      this.currimgtab = tab
      console.log(tab)
    },
    tabnav: function (tab) {
      this.active = tab
    },
    catinputclick: function () {
      alert('dsdsd')
    },
    /**
     * 初始化店铺分类
     */
    initcategory: function () {
      this.currCatgery = {route: '店铺根目录'}
      this.LoadChildCategory(0)
    },
    /**
     * 反回分类根目录
     */
    initCralcategory: function () {
      this.currCralCategory = {route: '店铺根目录'}
      this.loadCralCategory(0)
    },
    /**
     * 搜索提交
     * @param formname
     */
    sSubmit: function (formname) {
      var that = this
      that.$refs[formname].validate(valid => {
        if (valid) {
          that.handleCurrentChange(1)
        }
      })
    },
    handtabclick: function (tab, event) {
      var tabid = event.target.id
      this.currimgtab = tabid.split('-')[1]
    },
    /**
     * 生成子变体
     */
    vargenerator: function () {
      var varList = []
      for (var i = 0; i < this.baseinfo.standard.length; i++) {
        for (var j = 0; j < this.baseinfo.standard[i].tag.length; j++) {
          var temp = []
          for (var k = 0; k < this.baseinfo.standard[i].tag[j].value.split(',').length; k++) {
            var extag = this.baseinfo.standard[i].tag[j]
            extag.currAttribute = this.baseinfo.standard[i].tag[j].value.split(',')[k]
            var varkey = {
              key: this.baseinfo.standard[i].tag[j].value.split(',')[k],
              group: this.baseinfo.standard[i],
              tag: extag
            }
            temp.push(varkey)
            if (this.baseinfo.standard[i].tag[j].isImages) {
              var tk = this.baseinfo.standard[i].name + '_' + this.baseinfo.standard[i].tag[j].name
              if (this.imagesMap[tk] === undefined) {
                this.imagesMap[tk] = {
                  group: this.baseinfo.standard[i],
                  attri: this.baseinfo.standard[i].tag[j],
                  spec: {}
                }
              }
              var dd = {
                list: [],
                cover: '',
                key: this.baseinfo.standard[i].tag[j].value.split(',')[k]
              }
              if (this.imagesMap[tk].spec[this.baseinfo.standard[i].tag[j].value.split(',')[k]] === undefined) {
                this.imagesMap[tk].spec[this.baseinfo.standard[i].tag[j].value.split(',')[k]] = dd
              }
            }
          }
          varList.push(temp)
        }
      }
      var data = {
        method: 'base.varcreater',
        srcList: JSON.stringify(varList)
      }
      var that = this
      var spu = that.baseinfo
      that.$http.post(that.$apiurl, data).then(function (ret) {
        for (var s = 0; s < ret.body.data.length; s++) {
          var dd = {}
          dd['listingPrice'] = spu.listingPrice
          dd['salePrice'] = spu.salePrice
          dd['qty'] = spu.qty
          dd['standard'] = ret.body.data[s]
          dd['standardString'] = ret.body.data[s].keyString
          that.$set(that.variant, s, dd)
        }
      })
    },
    basenext: function (formName) {
      var that = this
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          that.vargenerator()
          that.baseboxvisible = true
          that.attributeboxvisible = false
          that.active++
        } else {
          that.$alert('请详细检查必填参数项，并认填填写')
        }
      })
    },
    steptoattri: function (formName) {
      this.attrlistboxvisible = false
      this.attributeboxvisible = true
      this.active++
    },
    catrgorypopover: function () {
      alert('dsdsdsdsd')
    },
    currCategoryClick: function () {
    },
    makeNewListing: function () {
      this.listDiaVisiable = true
    },
    handChildChange: function (val) {
      console.log(val)
    },
    LoadChildCategory (pid) {
      var that = this
      var params = {
        PID_id: pid,
        method: 'shop.childcategory'
      }
      this.$http.post(that.$apiurl, params).then(function (ret) {
        that.cloading = false
        var getdata = ret.body.data
        if (getdata.length > 0) {
          that.currCategoryList = ret.body.data
        } else {
          that.popshow = false
          that.baseinfo['category_id'] = pid
          that.loadtags(pid)
          that.loadattr(pid)
        }
      })
    },
    loadCralCategory: function (pid) {
      var that = this
      var params = {
        PID_id: pid,
        method: 'shop.childcategory'
      }
      this.$http.post(that.$apiurl, params).then(function (ret) {
        that.flloading = false
        var getdata = ret.body.data
        if (getdata.length > 0) {
          that.currcwalCategoryList = ret.body.data
        } else {
          that.cralpopshow = false
          that.currCwal.category_id = pid
        }
      })
    },
    loadtags: function (catid) {
      var that = this
      var params = {
        method: 'shop.shopcatgorytags',
        category_id: catid,
        attrigroup__isCartAttri: true
      }
      that.fullLoad()
      this.$http.post(that.$apiurl, params).then(function (ret) {
        that.hasloaded()
        that.currAttribute = ret.body.data
        var data = ret.body.data
        var standard = []
        that.imagesMap = {}
        data.forEach(function (taggp, index) {
          console.log(taggp)
          var gp = {}
          gp['name'] = taggp.information.name
          gp['showName'] = taggp.information.showName
          gp['ID'] = taggp.ID
          var tList = []
          taggp.tag.forEach(function (currtag) {
            var temp = {}
            temp['ID'] = currtag.ID
            temp['name'] = currtag.name
            temp['showName'] = currtag.showName
            temp['isImages'] = currtag.isImages
            tList.push(temp)
          })
          gp['tag'] = tList
          standard.push(gp)
        })
        that.baseinfo['standard'] = standard
      })
    },
    loadattr: function (catid) {
      var that = this
      var params = {
        method: 'shop.shopcatgorytagmap',
        category_id: catid,
        attrigroup__isCartAttri: false
      }
      this.$http.post(that.$apiurl, params).then(function (ret) {
        var data = ret.body.data
        data.forEach(function (currgroup, index) {
          var mapL = currgroup.mapList
          console.log(mapL)
          mapL.forEach(function (curr, keyseries) {
            var key = currgroup.information.name + '_' + curr.taginformation.name.replace(' ', '-')
            var params = {}
            params['group'] = mapL.information
            params['taginfomation'] = curr.taginformation
            params['valueList'] = curr.valueList
            params.value = ''
            that.$set(that.attrlist, key, params)
            if (curr.valueList[0]) {
              that.$set(that.canshu, key, curr.valueList[0].value)
            } else {
              that.$set(that.canshu, key, '')
            }
          })
        })
      })
    },
    categorychecked: function (obj) {
      this.cloading = true
      this.LoadChildCategory(obj.ID)
      this.currCatgery = obj
    },
    cwalcategorychecked: function (obj) {
      this.flloading = true
      this.loadCralCategory(obj.ID)
      this.currCralCategory = obj
    },
    pushtobox: function (response, file, fileList) {
      var extendkey = this.currimgtab.split('_')
      var currkey = extendkey.pop()
      var tar = extendkey.join('_')
      this.$set(this.imagesMap[tar].spec[currkey]['list'], this.imagesMap[tar].spec[currkey]['list'].length, response.data.url)
      this.reshowvaribox()
    },
    handimgclick: function (imgurl) {
      var extendkey = this.currimgtab.split('_')
      var currkey = extendkey.pop()
      var tar = extendkey.join('_')
      this.$set(this.imagesMap[tar].spec[currkey], 'cover', imgurl)
      this.reshowvaribox()
    },
    handImgRemove: function (index) {
      var extendkey = this.currimgtab.split('_')
      var currkey = extendkey.pop()
      var tar = extendkey.join('_')
      this.imagesMap[tar].spec[currkey]['list'].splice(index, 1)
      this.reshowvaribox()
    },
    editskurow: function (v, r) {
      this.currVariaCol = r
      this.currVariaCol.idKey = v
      this.vareditboxshow = true
    },
    handleRemoveClick: function (index) {
      this.variant.splice(index, 1)
    },
    skuUpdate: function () {
      var data = this.currVariaCol
      var index = data.idKey
      delete data.idKey
      this.variant.splice(index, 1, data)
      this.vareditboxshow = false
      this.$message.success('变体修改成功')
    },
    reshowvaribox: function () {
      this.attributeboxvisible = true
      this.attributeboxvisible = false
    },
    loadcountry: function () {
      var data = {
        method: 'base.country'
      }
      var that = this
      this.$http.post(that.$apiurl, data).then(function (ret) {
        that.country = ret.body.data
      })
    },
    applynow: function () {
      var that = this
      that.$refs['canshu'].validate(valid => {
        if (valid) {
          Object.keys(this.canshu).forEach(function (key) {
            console.log(key)
            console.log(that.canshu[key])
            that.attrlist[key].value = that.canshu[key]
          })
          var data = {
            info: JSON.stringify(this.baseinfo),
            imgList: JSON.stringify(this.imagesMap),
            variant: JSON.stringify(this.variant),
            attriList: JSON.stringify(this.attrlist),
            method: 'shop.addnewproduct'
          }
          this.$http.post(that.$apiurl, data).then(function (ret) {
            if (ret.body.data.code === 200) {
              that.$message.success('产品提交成功!')
              that.listDiaVisiable = false
              that.handleCurrentChange(1)
            } else {
              that.$alert('产品提交失败，请稍后重试！')
            }
          })
        }
      })
    },
    handleCurrentChange: function (page) {
      var params = {}
      params['page'] = page
      params['num'] = 12
      params['method'] = 'shop.productpage'
      if (this.sData.keywords) {
        params['q'] = this.sData.keywords
      }
      var that = this
      that.pageloading = true
      this.$http.post(that.$apiurl, params).then(function (ret) {
        that.pageinfo = ret.body.data
        that.pageloading = false
      })
    },
    spustate: function (data) {
      if (data.status) {
        return ('在售')
      } else {
        return ('禁售')
      }
    },
    handlespustate: function (row) {
      var para = {}
      para.method = 'shop.spustate'
      para.spu = row.spu
      var that = this
      that.$http.post(that.$apiurl, para).then(function (ret) {
        if (ret.body.data.code === 200) {
          that.$message.success('产品状态修改在功')
          that.handleCurrentChange(that.pageinfo.page)
        } else {
          that.$alert('产品状态修改失败，请稍后重试！')
        }
      })
    },
    showEditBox: function (row) {
      this.editdiashow = true
      this.curreditspu = row
    },
    handleSpuUpdate: function (formName) {
      var that = this
      that.$refs[formName].validate(function (valid) {
        if (valid) {
          var para = that.curreditspu
          delete para.ID
          delete para.standard
          delete para.attribute
          delete para.images
          delete para.category
          delete para.child
          delete para.currency
          delete para.sku
          delete para.cover
          delete para.figure
          delete para.updateAt
          delete para.creatAt
          para.method = 'shop.updatebaseinfo'
          that.$http.post(that.$apiurl, para).then(function (ret) {
            if (ret.body.data.code === 200) {
              that.$message.success('产品修改在功')
              that.handleCurrentChange(that.pageinfo.page)
            } else {
              that.$alert('产品修改失败，请稍后重试！')
            }
          })
        }
      })
    },
    cwaNow: function (formname) {
      var that = this
      if (that.cwalData.cralurl !== undefined) {
        that.$http.post(that.$apiurl, {method: 'base.genuuid'}).then(function (res) {
          var uuid = res.body.data.uid
          console.log(uuid)
          that.cwaluuid = uuid
          that.Interval = setInterval(function () {
            var para = {}
            para.method = 'extend.cwalresult'
            para.uid = uuid
            that.$http.post(that.$apiurl, para).then(function (cr) {
              if (cr.body.data.result !== null) {
                window.clearInterval(that.Interval)
                try {
                  that.hasloaded()
                } catch (e) {
                  console.log(e)
                }
                that.$message.success('产品采集成功')
                that.currCwal = cr.body.data.result
              }
            })
          }, 5000)
          setTimeout(function () {
            console.log('time work')
            window.clearInterval(that.Interval)
          }, 360000)
          var para = {}
          para.method = 'extend.cwal'
          para.cwalurl = that.cwalData.cralurl
          para.uid = uuid
          that.fullLoad()
          that.$http.post(that.$apiurl, para).then(function (ret) {
            that.hasloaded()
            if (ret.body.code === 900) {
              that.$alert('用户余额不足，请先行充值再行使用')
            } else {
              that.$message.warning(ret.body.msg)
            }
          })
        })
      } else {
        that.$message.error('请输入正确的地址采集产品信息')
      }
    },
    handleCral: function (formname) {
      var that = this
      that.$refs[formname].validate(valid => {
        if (valid) {
          var para = that.currCwal
          para.method = 'extend.applycwalproduct'
          that.fullLoad()
          that.$http.post(that.$apiurl, para, {emulateJSON: false}).then(function (ret) {
            that.hasloaded()
            if (ret.body.code === 200) {
              that.$message.success('产品挂单成功')
              that.handleCurrentChange(1)
            } else {
              that.$message.warning(that.body.msg)
            }
          })
        }
      })
    },
    removeSpu: function (spu) {
      var that = this
      var para = {}
      para.method = 'shop.removeproduct'
      para.spu = spu
      that.fullLoad()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.hasloaded()
        if (ret.body.code === 200) {
          that.$alert('产品删除成功!')
          that.handleCurrentChange(that.pageinfo.page)
        } else {
          that.$message.warning(ret.body.msg)
        }
      })
    },
    GetEditVariant: function (row) {
      this.editvariant = row.child
      this.showvarianteditbox = true
    }
  }
}
</script>
<style scoped>
  .showcell:hover{box-shadow: 0 2px 12px 0 rgba(0,0,0,0.4)}
</style>



// WEBPACK FOOTER //
// src/components/shop/Listing.vue